import Backbone from 'backbone'

class Message extends Backbone.Model {
    initialize () {
        if (!this.get('subclass')) {
            this.set('subclass', '')
        }

        if (!this.get('timer')) {
            this.set('timer', 4000)
        }
    }

    validate () {
        const errors = []

        if (!this.get('message')) {
            errors.push('O atributo \'message\' [Mensagem do Alert] é obrigatório')
        }

        if (!this.get('type')) {
            errors.push('O atributo \'type\' [Tipo do alert: warning|error|success] é obrigatório')
        }

        if (errors.length > 0) return errors
    }
}

export default Message
